import { render, staticRenderFns } from "./BillShareDepartment.vue?vue&type=template&id=8a65b11a&"
import script from "./BillShareDepartment.vue?vue&type=script&lang=js&"
export * from "./BillShareDepartment.vue?vue&type=script&lang=js&"
import style0 from "./BillShareDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports